import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import Guide from "@/pages/guide/page";
import LocaleRedirect from "@/pages/LocaleRedirect";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LocaleRedirect />,
  },
  {
    path: "/:lang",
    element: <Home />,
  },
  {
    path: "/:lang/usfans-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/:lang/guides/:slug",
    element: <Guide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;